import axios from './axiosInstances/axiosInstance';

export const createBasket = (restaurantId) => {
  return axios.post(`baskets`, {
    restaurantid: restaurantId,
  });
};
